const POPUP_WIDTH = 480;
const POPUP_HEIGHT = 720;
const POLL_MS = 500;

const features = () => {
  const left = window.screenX + Math.max(0, (window.outerWidth - POPUP_WIDTH) / 2);
  const top = window.screenY + Math.max(0, (window.outerHeight - POPUP_HEIGHT) / 2);

  return `width=${POPUP_WIDTH},height=${POPUP_HEIGHT},left=${Math.round(left)},top=${Math.round(top)}`;
};

export const openPaystackPopup = (authorizationUrl) => {
  const popup = window.open(authorizationUrl, "sayagie-paystack", features());

  if (!popup || popup.closed) return null;

  popup.focus?.();

  return popup;
};

export const openBlankPopup = () => openPaystackPopup("about:blank");

export const sendPopupTo = (popup, authorizationUrl) => {
  try {
    popup.location.replace(authorizationUrl);
    popup.focus?.();

    return true;
  } catch {
    return false;
  }
};

export const closePopup = (popup) => {
  try {
    popup?.close();
  } catch {
    /* already gone */
  }
};

export const waitForPopupClose = (popup) =>
  new Promise((resolve) => {
    const timer = setInterval(() => {
      if (!popup.closed) return;

      clearInterval(timer);
      resolve();
    }, POLL_MS);
  });
